import { formatDateTime } from '@/lib/utils'
import type { UserListItem } from '@/types/user'
import type { GridColDef } from '@mui/x-data-grid'

export type UserRow = Omit<UserListItem, 'registeredAt'> & {
  registeredAt: Date | null
}

export const columns: GridColDef<UserRow>[] = [
  {
    field: 'displayName',
    headerName: 'User',
    flex: 1,
    minWidth: 180,
    valueGetter: (_value, row) => row.displayName || row.niceName
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 1,
    minWidth: 200
  },
  {
    field: 'phone',
    headerName: 'Mobile',
    flex: 1,
    minWidth: 160
  },
  {
    field: 'registeredAt',
    headerName: 'Registered on',
    flex: 1,
    minWidth: 200,
    type: 'dateTime',
    valueFormatter: value => formatDateTime(value)
  }
]
